import { Drawer as AntDrawer } from "antd";

const Drawer = ({
  children,
  open,
  onClose,
  placement = "bottom",
  closable=true,
  title,
  width = 400,
  height=500,
  extra,
  className,
  style

}) => {
  return (
    <>
      <AntDrawer
        title={title}
        placement={placement}
        onClose={onClose}
        open={open}
        closable={closable}
        width={width}
        height={height}
        extra={extra}
        className={className}
        style={style}
      >
        {children}
      </AntDrawer>
    </>
  );
};

export default Drawer;